import { Check } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

interface RadioFormProps {
    label: string
    isCompleted: boolean
    step: number
}

export function RadioForm({ label, isCompleted, step }: RadioFormProps) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '8px' }}>
            {isCompleted ? (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 34, width: 34, borderRadius: '50%', backgroundColor: 'green' }}>
                        <Check sx={{ color: 'white', width: 20 }} />
                    </Box>
                    <Typography sx={{ color: 'white', fontWeight: 'bold' }}>
                        {label}
                    </Typography>
                </>
            ) : (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 34, width: 34, borderRadius: '50%', backgroundColor: 'darkgray' }}>
                        <Typography sx={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>
                            {step}
                        </Typography>
                    </Box>
                    <Typography sx={{ color: 'white', fontWeight: 'bold' }}>
                        {label}
                    </Typography>
                </>
            )}
        </Box>
    );

}